import { Box, Chip, Typography } from '@mui/material';

import RunSummaryAgentList from './RunSummaryAgentList';
import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function DecisionBrief({ fallbackHeadline, topLine = {} }) {
  const hasTopLine =
    topLine.status ||
    topLine.plainSummary ||
    topLine.mainReason ||
    topLine.releaseRecommendation ||
    topLine.qaNextStep;

  if (!hasTopLine) return null;

  return (
    <Box sx={runSummaryAgentReportStyles.decisionPanel}>
      <Box sx={runSummaryAgentReportStyles.decisionHeader}>
        <Box>
          <Typography variant="overline" color="text.secondary">
            At a glance
          </Typography>
          <Typography variant="h6" sx={runSummaryAgentReportStyles.decisionTitle}>
            {fallbackHeadline || 'Run Summary'}
          </Typography>
        </Box>
        {topLine.status && (
          <Chip
            size="small"
            label={topLine.status}
            sx={runSummaryAgentReportStyles.decisionStatusChip}
          />
        )}
      </Box>

      {topLine.plainSummary && (
        <Typography variant="body1" sx={runSummaryAgentReportStyles.decisionSummary}>
          {topLine.plainSummary}
        </Typography>
      )}

      <Box sx={runSummaryAgentReportStyles.briefGrid}>
        <Box>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitleNoMargin}>
            Main reason
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {topLine.mainReason || 'No main reason provided.'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitleNoMargin}>
            Release recommendation
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {topLine.releaseRecommendation || 'No release recommendation provided.'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitleNoMargin}>
            QA next step
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {topLine.qaNextStep || 'Review the top failed flows and scenarios.'}
          </Typography>
        </Box>
      </Box>

      {topLine.why?.length > 0 && (
        <Box sx={runSummaryAgentReportStyles.whyBox}>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitleNoMargin}>
            Why
          </Typography>
          <RunSummaryAgentList items={topLine.why} />
        </Box>
      )}
    </Box>
  );
}
